import { render, staticRenderFns } from "./CalendarDateIndicator.vue?vue&type=template&id=857ef37c&scoped=true"
import script from "./CalendarDateIndicator.vue?vue&type=script&lang=js"
export * from "./CalendarDateIndicator.vue?vue&type=script&lang=js"
import style0 from "./CalendarDateIndicator.vue?vue&type=style&index=0&id=857ef37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857ef37c",
  null
  
)

export default component.exports